// @flow
import styled from 'styled-components'
import theme from '../../../../../styles/theme'

const HEADER_HEIGHT = 49
const FOOTER_HEIGHT = 186
const EASING_BEZIER = 'cubic-bezier(0.165, 0.84, 0.44, 1)'

export const MainWrapper = styled.div`
  .drawer-wrapper-enter {
    transform: translateX(-100%);
    opacity: 0.7;
  }
  .drawer-wrapper-enter-active {
    transform: translateX(0);
    opacity: 1;
    transition: transform 0.6s ${EASING_BEZIER}, opacity 0.6s ${EASING_BEZIER};
  }
  .drawer-wrapper-exit-active {
    transform: translateX(-100%);
    opacity: 0.7;
    transition: transform 0.6s ${EASING_BEZIER}, opacity 0.6s ${EASING_BEZIER};
  }

  .drawer-wrapper-enter-done:before {
    max-height: 100%;
  }
`

export const DrawerWrapper = styled.div`
  display: block;
  position: fixed;
  top: 49px;
  left: 0;
  width: 100%;
  height: ${props => Math.floor(props.height - HEADER_HEIGHT)}px;
  z-index: 50;
  overflow: auto;
  background-color: ${theme.white};
  color: ${theme.black};

  &:before {
    display: block;
    content: '';
    position: fixed;
    top: 49px;
    left: 0;
    width: 100%;
    overflow: hidden;
    height: ${props => Math.floor(props.height + 600)}px;
    max-height: 0;
    z-index: -1;
    background-color: ${theme.white};
  }
`

export const DrawerContent = styled.div`
  display: block;
  position: relative;
`

export const DrawerBody = styled.div`
  min-height: ${props =>
    Math.floor(props.height - HEADER_HEIGHT - FOOTER_HEIGHT)}px;
`

export const DrawerFooter = styled.div`
  box-sizing: border-box;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 90px 1.35rem 20px;
`

export const TextInfo = styled.p`
  font-size: 0.7rem;

  & > b {
    margin-left: 0.1rem;
  }

  a {
    color: ${theme.black};
    text-decoration: none;
  }
`

export const ButtonHamburger = styled.button`
  display: flex;
  position: relative;
  box-sizing: border-box;
  user-select: none;
  width: 24px;
  height: 24px;
  margin-right: 16px;
  cursor: pointer;
  border: none;
  background-color: transparent;
  -webkit-tap-highlight-color: transparent;

  &:focus {
    outline: none;
  }

  &:before,
  &:after,
  & > span {
    display: block;
    position: absolute;
    left: 3px;
    width: 18px;
    height: 2px;
    background-color: ${theme.black};
    transition: ${theme.transitionDefault};
  }

  &:before,
  &:after {
    content: '';
  }

  &:before {
    top: 6px;
    transform: ${props =>
    props.isOpen
      ? 'translateY(5px) rotate(45deg)'
      : 'translateY(0) rotate(0deg)'};
  }

  &:after {
    bottom: 6px;
    transform: ${props =>
    props.isOpen
      ? 'translateY(-5px) rotate(-45deg)'
      : 'translateY(0) rotate(0deg)'};
  }

  & > span {
    top: 11px;
    background-color: ${props => (props.isOpen ? 'transparent' : theme.black)};
  }
`
export const PanelWrapper = styled.div`
  border-bottom: 1px solid ${theme.black};

  p {
    margin: 0;
  }
`

export const PanelHeader = styled.div`
  position: relative;
  font-size: 1.375rem;
  a {
    width: 100% !important;
  }
  p {
    padding: 0.55rem 1.35rem;
  }
`

export const PanelBody = styled.div`
  display: block;
  box-sizing: border-box;
  overflow: hidden;
  height: ${props => props.height + 'px'};
  transition: ${props =>
    props.isTransitionActive ? 'height 0.4s ' + EASING_BEZIER : 'none'};
`

export const PanelList = styled.div`
  padding: 0.85rem 3.425rem 1.6rem;
`

export const PanelItem = styled.div`
  a {
    width: auto !important;
    color: ${props => (props.active ? theme.red : '#7d7d7d')};
    font-size: 1.2rem;
    line-height: 2.3rem;
    text-decoration: none;
  }
`

export const IconWrapper = styled.span`
  position: absolute;
  top: 0.7rem;
  right: 1rem;

  & > svg {
    transition: ${theme.transitionDefault};
    transform: ${props => (props.isActive ? 'rotate(180deg)' : 'rotate(0deg)')};
  }
`
